(function() {
  'use strict';

  function initScrollAnimations() {
    var elements = document.querySelectorAll('.animate-on-scroll');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    // threshold: 0 rather than 0.1. A section taller than ~10x the viewport can
    // never show 10% of itself at once, so it stayed at opacity 0 forever — that
    // is how a fast flick to the end of the blog left the footer's social,
    // payment and copyright rows unpainted. The negative bottom margin keeps the
    // "just come into view" feel that the 0.1 was reaching for.
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

    elements.forEach(function(el) { observer.observe(el); });

    // Content must never stay invisible because an observer did not fire.
    function revealWhateverIsOnScreen() {
      setTimeout(function() {
        document.querySelectorAll('.animate-on-scroll:not(.is-visible)').forEach(function(el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
        });
      }, 400);
    }

    // Attaching a load listener after load has already fired would never run,
    // which is exactly the case this net exists for.
    if (document.readyState === 'complete') {
      revealWhateverIsOnScreen();
    } else {
      window.addEventListener('load', revealWhateverIsOnScreen);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      requestAnimationFrame(initScrollAnimations);
    });
  } else {
    requestAnimationFrame(initScrollAnimations);
  }
})();
